import axios from "axios";
import { API_BASE_URL } from "../constant";

export const createSalesAdvance = async (payload) => {
  const userToken = localStorage.getItem("user_token");

  try {
    const response = await axios.post(
      `${API_BASE_URL}/sales_advance`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${userToken}`, // Use Bearer if required
        },
        withCredentials: true,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error creating sales advance:", error);
    throw error;
  }
};
